<template>
  <PagesCountAreaReport
      :items="items"
      :pfilters="$route.params.filters"
      :region-id="$route.params.regionId"
      @updated="onUpdate"
  />
</template>

<script>
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import ReportService from "@/services/report.service"
import _ from "underscore"
import Mapper from "@/mappers"
import Moment from "moment";
import {AllowStatistics} from "@/enums/permission";
import PagesCountAreaReport from "@/components/report/CostAnalysisStatistics/PagesCountAreaReportComponent.vue";

export default {
  name: "PagesCountAreaReportView",
  components: {
    PagesCountAreaReport
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {
      let regionId = this.$route.params.regionId;
      const {start, end, date, selectedFilters, selectedAreas, isAllClientsSelected, isArchive, clients} = filters;
      if (selectedFilters && selectedFilters.includes(3) && !selectedFilters.includes(2)) {
        selectedFilters.push(2);
      }

      this.$store.dispatch(LAYOUT_LOADING_START)
      ReportService.getPagesCountAreaReport({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
        regionId : regionId,
        date: date ? Moment(date, "YYYY-MM") : null,
        selectedFilters: selectedFilters ? selectedFilters : null,
        selectedAreas: selectedAreas ? selectedAreas : null,
        isAllClientsSelected: isAllClientsSelected,
        type: isArchive,
        clients: clients
      })
          .then(response => {
            this.items = _.map(response.data, rvm => {
              return {
                area: Mapper.mapArea(rvm.Area),
                received: rvm.Received,
                pagesCount: rvm.PagesCount,
                printedMailsPagesCount: rvm.PrintedMailsPagesCount,
              }
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, "Статистика бумага по районам")
    }
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>
